import type { ThreeEvent } from '@react-three/fiber'
import { PREFIXO_SELECIONAVEL } from '../camera/comandosCamera'
import { Rotulo3D } from '../componentes/Rotulo3D'
import type { PredioBloco, UsoPredio } from '../../dominio/cenario/predios'

const ALTURA_ANDAR = 3

const COR_USO: Record<UsoPredio, string> = {
  residencial: '#9aa3ad',
  comercial: '#8c97a6',
  escola: '#b59f6a',
  hospital: '#d9dde2',
  industria: '#7d8072',
}

export interface PropsPredioBloco3D {
  predio: PredioBloco
  /** Cor de destaque quando o prédio está dentro de uma zona calculada. */
  destaque?: string | null
  selecionado?: boolean
  mostrarNome?: boolean
  aoSelecionar?: (id: string) => void
}

/**
 * Prédio em bloco: caixa com faixas de andar. É o "alvo" das zonas — o que
 * está dentro de cada anel ganha a cor da zona, e é isso que o aluno lê.
 */
export function PredioBloco3D({ predio, destaque = null, selecionado = false, mostrarNome = false, aoSelecionar }: PropsPredioBloco3D) {
  const andares = Math.max(1, Math.round(predio.alturaM / ALTURA_ANDAR))
  const cor = destaque ?? COR_USO[predio.uso]
  return (
    <group position={[predio.x, 0, predio.z]}>
      <mesh
        name={`${PREFIXO_SELECIONAVEL}predio-${predio.id}`}
        position={[0, predio.alturaM / 2, 0]}
        castShadow
        receiveShadow
        onClick={
          aoSelecionar
            ? (evento: ThreeEvent<MouseEvent>) => {
                evento.stopPropagation()
                aoSelecionar(predio.id)
              }
            : undefined
        }
      >
        <boxGeometry args={[predio.larguraM, predio.alturaM, predio.profundidadeM]} />
        <meshStandardMaterial
          color={cor}
          roughness={0.85}
          emissive={selecionado ? '#ffb347' : destaque ?? '#000000'}
          emissiveIntensity={selecionado ? 0.4 : destaque ? 0.25 : 0}
        />
      </mesh>
      {/* faixas de janela, uma por andar */}
      {Array.from({ length: andares }, (_, i) => (
        <mesh key={i} position={[0, ALTURA_ANDAR * i + ALTURA_ANDAR * 0.55, 0]} raycast={() => null}>
          <boxGeometry args={[predio.larguraM + 0.04, 0.9, predio.profundidadeM + 0.04]} />
          <meshStandardMaterial color="#26323d" roughness={0.3} metalness={0.4} />
        </mesh>
      ))}
      {mostrarNome && <Rotulo3D posicao={[0, predio.alturaM + 3, 0]} texto={predio.nome} fator={60} />}
    </group>
  )
}
